import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/dist/vuetify.css';
import 'material-design-icons/iconfont/material-icons.css';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import theme from './theme';

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme,
  defaults: {
    VBtn: { variant: 'elevated' },
    VTextField: { variant: 'underlined' },
    VSelect: { variant: 'underlined' },
    VTextarea: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
  },
});
